export class TrackResult {

    applicationStatus: string;

    brandName: string;

    modelName: string;

    variantName: string;

    customerName: string;

    quotationNo: string;

    exShowroomPrice: number;

    basicInstallment: number;

    tenureMonths: number;

    interestRate : number;

    portfiolioId: number
    quotationId: string
    custId: string
    quotStatusId: string



}